import axios from "axios"
import { Apis } from "constants/apis";
import { TGetExtensionSettingsService } from "types/services"

const getExtensionSettings: TGetExtensionSettingsService = async() => {
    const { data } = await axios.get(Apis.GET_SETTINGS)
    return data
}

export default getExtensionSettings